import { AuthProvider } from './auth.service';
import { get as getLocal, set as setLocal } from '../local-storage';
import { has } from 'lodash';
import { isValidTabId, TAB_ID } from '@/components/app-sidebar/helpers';

// const AGENT_GREETING_PHRASES: readonly { id: string; text: string }[] = [
//   { id: 'get-done-today', text: 'What would you like to get done today?' },
//   { id: 'top-of-list-today', text: "What's at the top of your list today?" },
//   { id: 'support-goals-today', text: 'How can I best support your goals today?' },
//   { id: 'knock-out-park', text: 'What can we knock out of the park today?' },
//   { id: 'today-feel-win', text: 'What would make today feel like a win?' },
//   { id: 'tackling-first', text: 'What are we tackling first?' },
//   { id: 'ready-start-priority', text: "Ready to start? What's the priority?" },
//   { id: 'anything-specific-today', text: 'Anything specific you want to handle today?' },
//   { id: 'ready-whenever', text: "I'm ready whenever you are :-)" },
// ] as const;

/** Persisted open/collapsed state for the desktop app sidebar link strip and tab panel. */
export type SidebarBarsOpenState = {
  linkBarOpen: boolean;
  activeTab: TAB_ID | null;
};

const getSidebarBarsLocalStorageKey = (): string => `sidebar-bars-open-${AuthProvider.spUserId}`;

export const getSidebarBarsOpenState = (): SidebarBarsOpenState | null => {
  if (!AuthProvider.spUserId) {
    return null;
  }

  const localSettings = getLocal(
    getSidebarBarsLocalStorageKey(),
    true
  ) as Partial<SidebarBarsOpenState> | null;

  if (!localSettings || !has(localSettings, 'linkBarOpen')) {
    return null;
  }

  const { linkBarOpen, activeTab } = localSettings;

  return {
    linkBarOpen: !!linkBarOpen,
    activeTab: isValidTabId(activeTab) ? activeTab! : null,
  };
};

export const setSidebarBarsOpenState = (state: SidebarBarsOpenState): void => {
  if (!AuthProvider.spUserId) {
    return;
  }

  setLocal(getSidebarBarsLocalStorageKey(), state);
};
